import { classNames, designSystem } from '@/util/tailwindHelpers'
import { formattedPacificDate } from '@/util/time/pt'
import { ButtonLink } from '@/components/Button'
import React, { Ref } from 'react'
import Timeline from '@/components/Timeline'
import { MergedSeason } from '../types'
import { HOW_TO_PLAY_PATH } from '../hooks/routing'

// @todo - stevei - this is a simplified temporary component for the arcade preseason that we will want to abstract to be more generic.
// should handle both drop and arcade timelines

export const ArcadeImportantDatesTimeline = React.forwardRef(
  (
    {
      season,
      config
    }: {
      season: MergedSeason
      config?: {
        isVertical?: boolean
        textAlign?: 'center' | 'left'
        buttonTheme?: 'clean-blue' | 'secondary' | 'clean-arcade'
        headerClasses?: string
        descriptionClasses?: string
        eventLocation: string
        states: {
          isLaunched: boolean
          isRedemptionOpen: boolean
          isPostRedemption: boolean
          isShipping: boolean
          isPostShipping: boolean
        }
      }
      eventLocation?: string
    },
    ref: Ref<HTMLDivElement>
  ) => {
    const {
      startAt,
      redeem_start_date,
      redeem_end_date,
      estimated_ship_target
    } = season

    const {
      isLaunched,
      isRedemptionOpen,
      isPostRedemption,
      isShipping,
      isPostShipping
    } = config.states

    const textAlign = config?.textAlign === 'left' ? 'text-left' : 'text-center'
    const descriptionClasses =
      config?.descriptionClasses || 'body-lg text-gray-300'
    const buttonTheme = config.buttonTheme || 'clean-blue'

    return (
      <div
        className={classNames({
          'space-y-8': !config.isVertical,
          'space-y-4': config.isVertical
        })}
        ref={ref}
      >
        <div
          className={classNames(
            'text-center max-w-2xl mx-auto space-y-2',
            textAlign
          )}
        >
          <p className="utility-alt w-max mx-auto mb-1 border-b-arcadeGreen border-b-[3px]">
            Season {season.id}
          </p>
          <h3 className={classNames('h3', config.headerClasses)}>
            Mark your calendar
          </h3>
          <p className={classNames(descriptionClasses)}>
            Keep an eye on the following dates so you don’t miss out on these
            limited-edition Season 1 physical collectibles!
          </p>
          <div className="h-[2px]" />
        </div>
        <Timeline
          activeColor={designSystem.colors.arcadeGreen}
          className="max-w-[1024px] mx-auto"
          isVertical={config.isVertical}
          textAlign={config.textAlign}
          isCompleted={isPostShipping}
          markers={[
            {
              title: formattedPacificDate(startAt),
              description: (
                <span>
                  Season 1 Opens
                  <br />
                  Convert & Compete
                </span>
              ),
              isActive: isLaunched
            },
            {
              title: formattedPacificDate(redeem_start_date),
              description: 'Season 1 Closes, Prizes Distributed Shortly After',
              isActive: isRedemptionOpen
            },
            {
              title: formattedPacificDate(redeem_end_date),
              description: 'Redemption is Closed',
              isActive: isPostRedemption
            },
            {
              title: estimated_ship_target,
              description: 'Physical Collectible Ships',
              isActive: isShipping
            }
          ]}
        />
        <ButtonLink
          theme={buttonTheme}
          size={buttonTheme === 'secondary' ? 'md' : 'lg'}
          href={HOW_TO_PLAY_PATH}
        >
          How To Play
        </ButtonLink>
      </div>
    )
  }
)
